import { useSelector } from "react-redux";
import { loggedInUser, selectAuthChecked } from "../Auth/Auth_Slice";
import { Navigate, useLocation } from "react-router-dom";
import FullPageLoader from "../../components/Common/FullPageLoader";

function ProtectedRoute({ children }) {
    const user = useSelector(loggedInUser);
    const authChecked = useSelector(selectAuthChecked);
    const location = useLocation();

    //  Agar API abhi bhi check kar rahi hai, then wait
    if (!authChecked) {
        return <FullPageLoader />;
    }

    // Jab check Pura ho jaye, aur phir bhi user na mile, then redirect to login
    if (!user || !user.isAuthenticated) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace={true} />;
    }

    //If everything all right
    return <>{children}</>;
}

export default ProtectedRoute;